import { t } from '@lingui/macro';

import appendUrlParams from '@rover/rsdk/src/modules/Network/appendUrlParams';
import { getAxiosInstance } from '@rover/rsdk/src/modules/Network/axios';
import type { Snakeify } from '@rover/rsdk/src/modules/Network/object-utilities';
import { camelize } from '@rover/rsdk/src/modules/Network/object-utilities';
import type { Breed } from '@rover/types';
import { fullApiUrl } from '@rover/utilities/apiUrl';

import DefaultAPIErrorHandler from './DefaultAPIErrorHandler';

export const BREEDS_URL: string = fullApiUrl('breeds/');

type GetOpts = { catBreeds?: boolean };

export const get = async (opts: GetOpts = {}): Promise<Breed[]> => {
  const ai = getAxiosInstance();

  try {
    const params = opts.catBreeds
      ? {
          pet_type: 'cat',
        }
      : '';
    const url = appendUrlParams(BREEDS_URL, params);
    const { data } = await ai.get<{ results: Snakeify<Breed[]> }>(url);
    return camelize(data.results, true);
  } catch (error: any) {
    return DefaultAPIErrorHandler(error, t`There was an error fetching breeds.`);
  }
};
